import React, { Component } from 'react';
import {Badge} from 'react-bootstrap';
import PanelView from '../model/PanelView.js';
import {clone} from '../util/Utility.js';

export default class EventPanelView extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      object: null,
    };

    this.state = {
      object: clone(props.objectPass),
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      this.state = clone(this.defaultState);
      this.setState({object: clone(newProps.objectPass)});
    }
  }

  render() {

    var object = this.state.object;

    return (
      <PanelView type="approval2" setState={this.setState.bind(this)} object={object} {...this.props}>
        <div style={{textAlign: 'left'}}>
          <h4>{object.sender || "Anonymous"}  {!object.seen && <Badge>New</Badge>}</h4>
          <div style={{height: 7}} />
          <p>{object.content}</p>
        </div>
      </PanelView>
    );

  }
}



/** WEBPACK FOOTER **
 ** ./src/encouragement/EncouragementPanelView.js
 **/